/**
 * Not used
 */
export default (kasko) => {
  kasko.addEventListener('form-changed', () => {
    const state = kasko.getState();
    const formState = kasko.getFormState();

    if (!state.route.state.url.includes('summary')) {
      return;
    }

    if (!formState.is_additional_info) {
      return;
    }

    kasko.dispatchEvent('set-state-input', {
      first_name: formState.lead_first_name,
      last_name: formState.lead_last_name,
      phone: formState.lead_phone,
      sales_agent: formState.lead_sales_agent,
      agent_first_name: formState.lead_agent_first_name,
      agent_last_name: formState.lead_agent_last_name,
      agent_email: formState.lead_agent_email,
      agent_company: formState.lead_agent_company,
      agent_number: formState.lead_agent_number,
    });
  });
};
